<template>
  <div>
    <CCard>
      <CCardHeader >
        <div class="m-0">
          <h2>{{title}}</h2>
        </div>
      </CCardHeader>
      <CCardBody>
        <vue-good-table 
          :columns="data.columns" 
          :rows="data.rows"
          :line-numbers="withLineNumber"
          :sort-options="{
            enabled: false,
          }"
          styleClass="vgt-table"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'uploadStatus'">
              <span v-if="props.row.uploadStatus === true">
                <CIcon name="cil-check-circle" class="text-success"/>
              </span>
              <span v-else>
                <CIcon name="cil-x-circle" class="text-danger"/>
              </span>
            </span>
            <span v-else class="h6">
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: "WidgetTable",
  props: {
    title: String,
    withLineNumber: Boolean, 
    data: {
      type: Object,
      default () {
        return {
          columns: [],
          rows: []
        }
      }
    },
  }
}
</script>